/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Content\Modals\ModalMakeReservation\ModalMakeReservation.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Monday June 24th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday June 24th 2024 5:37:08 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { MouseEventHandler } from "react";
import { useLang } from "Router/LangueProvider";
import styles from "Content/Modals/ModalMakeReservation/ModalMakeReservation.module.css";
import MyModal from "Content/Modals/MyModal";
import { Button } from "@mui/material";

type ModalMakeReservationProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    makeReservation: MouseEventHandler<HTMLButtonElement>,
    themeColor: string,
};

function ModalMakeReservation(props: ModalMakeReservationProps) {
    const {translator} = useLang();

    return (
        <MyModal closeModal={props.closeModal} show={props.show} onClose={props.onClose} addCloseCross={true} footer={(() => {return (<></>)})()} title={""} className={styles.modalCtaStyle} themeColor={props.themeColor} >
            <div className={`${styles.modal}`}>
                <p className="m-0">{translator.decode("modals.message.makeReservation")}</p>
                <p className="m-0">{translator.decode("modals.message.reservationWarning")}</p>
                <div>
                    <Button color="error" onClick={props.closeModal}>{translator.decode("dynamic.cancel")}</Button>
                    <Button variant="contained" className="ms-3" onClick={props.makeReservation}>{translator.decode("dynamic.confirm")}</Button>
                </div>
            </div>
        </MyModal>
    )
}

export default ModalMakeReservation;
